module.exports = __webpack_public_path__ + "static/media/ubrand_screens1.e04a7982.png";